const style = {
  checkbox: {
    border: `1px solid #666`
  },
  checkbox_check: {
    background: `#666`
  },
  input: {
    border: `1px solid #666`,
    background: `#fff`
  }
}

export default style



// WEBPACK FOOTER //
// ./src/components/Community/partials/CommunityCreator/style/ColorBlind/form.js